import { useState, useEffect } from 'react';
import { Card } from 'primereact/card';
import { Link } from 'react-router-dom';
import { AppRouteURL, AppRouteURLwithChilds, TestSereisRouteURL } from '@Constants/app-route-url.constant';
import { useAppSelector } from '@App/hooks';
import SvgIcon from '@Components/icons/SvgIcon';
import { Dialog } from 'primereact/dialog';
import { NoSubscriptionDialog } from '@Components/NoSubscriptionDialog/NoSubscriptionDialog';
import { useSubscriptionNavigation } from '@Src/hooks/useSubscriptionNavigation';
import './MockTests.scss';

const MockTests = ({ testList, classId, subject, isTestSeries, onLoadMore, hasMore, loading, isBoardPage, currentBoardId, currentBoardName, topicPriority }: any) => {
    const [loadMore, setLoadMore] = useState(false);
    const [list, setList] = useState([]);

    const loginData = useAppSelector((state: any) => state.login);
    const isLoggedIn = loginData?.isLoggedIn;
    const coursePreferences = useAppSelector((state: any) => state.coursePreferences);
    const isBoardMatched = (currentBoardId && coursePreferences?.boardDetails?.[0]?.Id && String(currentBoardId) === String(coursePreferences.boardDetails[0].Id));

    const { checkSubscriptionAndNavigate, subscriptionDialogProps, pendingTestDialogProps } = useSubscriptionNavigation();

    const isDiagnosticPage = window.location.pathname.includes(TestSereisRouteURL.DIAGNOSTIC_TEST_SERIES);
    const isPracticePage = window.location.pathname.includes(TestSereisRouteURL.TEST_SERIES);

    let seriesRouteURL: any;
    // isDiagnosticPage ? AppRouteURL.DIAGNOSTIC_MOCKTEST_SERIES : AppRouteURL.MOCKTEST_SERIES;
    switch (window.location.pathname) {
        case TestSereisRouteURL.TEST_SERIES:
            seriesRouteURL = AppRouteURL.MOCKTEST_SERIES;
            break;
        case TestSereisRouteURL.FULL_MOCK_TEST_SERIES:
            seriesRouteURL = AppRouteURL.FULL_MOCK_TEST_SERIES;
            break;
        case TestSereisRouteURL.DIAGNOSTIC_TEST_SERIES:
            seriesRouteURL = AppRouteURL.DIAGNOSTIC_MOCKTEST_SERIES;
            break;
        case TestSereisRouteURL.PREVIOUS_YEAR_MOCK_TEST_SERIES:
            seriesRouteURL = AppRouteURL.PREVIOUS_YEAR_MOCK_TEST_SERIES;
            break;
        default:
            seriesRouteURL = AppRouteURL.MOCKTEST_SERIES;

    }

    useEffect(() => {
        setList(testList);
    }, [testList]);

    const loadMoreClicked = () => {
        if (isTestSeries) {
            onLoadMore();
        } else {
            setLoadMore(true);
        }
    };

    let heading: any;
    switch (window.location.pathname) {
        case TestSereisRouteURL.DIAGNOSTIC_TEST_SERIES:
            heading = "Readiness Check";
            break;
        case TestSereisRouteURL.TEST_SERIES:
            heading = "Practice Test";
            break;
        case TestSereisRouteURL.FULL_MOCK_TEST_SERIES:
            heading = "Mock Test";
            break;
        case TestSereisRouteURL.PREVIOUS_YEAR_MOCK_TEST_SERIES:
            heading = "Previous Year Test";
            break;

        default:
            heading = "Practice Test";
            break;
    }


    return (
        <>
            <section className="most-popular-series-container ia-container px-2">
                <div className="mock-test-listing-header">
                    {topicPriority ? "Recommended Test" : (isTestSeries ? heading : `${heading}s`)}
                </div>

                <div className="most-popular-cards-container p-0" style={{ flex: 'none', display: 'block' }}>
                    {
                        list && list.length > 0 ? (
                            isTestSeries ?
                                list.map((element: any) => {
                                    return (
                                        <Card key={element.testSeriesId || element.Id} className='custome-card ia-testlist mb-5'>
                                            <div className='md:flex m-0 h-full'>
                                                <div className='ia-testlist-image-card tw-relative'>
                                                    <div className="ia-testlist-image">
                                                        <img
                                                            src={element.testSeriesImage || element.Image || "/noimage.png"}
                                                            alt={element.testSeriesName || element.Name}
                                                            onError={(e: any) => { e.target.src = "/noimage.png" }}
                                                            className="tw-w-full tw-h-full tw-object-cover"
                                                        />
                                                    </div>
                                                </div>
                                                <div className='ia-testlist-image-card-content px-3 md:pl-4 md:pr-2 pt-3'>
                                                    <div className='ia-testlist-header tw-flex tw-justify-between tw-items-start tw-gap-3 px-2 pt-2'>
                                                        <div className='tw-flex-1 flex-wrap' style={{ width: "100%" }}>
                                                            <div className='tw-flex tw-items-center tw-gap-1'>
                                                                <h2 className='tw-font-bold tw-text-xl lg:tw-text-2xl tw-inline tw-line-clamp-2'>{element.testSeriesName}   <span className='badge-difficulty-level tw-ml-2 tw-inline-flex tw-align-middle tw-text-sm tw-font-medium'>Level {element.difficultyLevel || 1}</span></h2>

                                                            </div>

                                                            {/* <p dangerouslySetInnerHTML={{ __html: element.Description.length > 180 ? `${element.Description.substring(0, 180)}...` : element.Description }} className='tw-mt-2  text-xs'></p> */}

                                                            <div dangerouslySetInnerHTML={{ __html: element.testSeriesDescription }} className='tw-mt-2  mb-2 test-description'></div>
                                                        </div>
                                                        <div className='tw-flex-shrink-0'>
                                                            {!isLoggedIn || !isBoardPage ? (
                                                                <button
                                                                    className='ia-btn ia-btn-primary py-2 px-6'
                                                                    onClick={() => checkSubscriptionAndNavigate(`${AppRouteURL.DASHBOARD}${seriesRouteURL}/${element.testSeriesId || element.Id}`)}
                                                                >
                                                                    <span className='tw-text-lg'>Take a Test</span>
                                                                </button>
                                                            ) : isBoardMatched ? (
                                                                <button
                                                                    className='ia-btn ia-btn-primary py-2 px-6'
                                                                    onClick={() => checkSubscriptionAndNavigate(`${AppRouteURL.DASHBOARD}${seriesRouteURL}/${element.testSeriesId || element.Id}`)}
                                                                >
                                                                    <span className='tw-text-lg'>Take a Test</span>
                                                                </button>
                                                            ) : (
                                                                <span className='tw-bg-red-500 tw-text-white tw-px-4 tw-py-2 tw-rounded tw-text-sm tw-font-medium tw-inline-block'>
                                                                    {currentBoardName} is not your target exam
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    <div className='ia-testlist-subheader pb-2'>
                                                        <div className='grid mt-2 px-2 align-items-center'>
                                                            <div className='col-6 lg:col-auto flex align-items-center'>
                                                                <SvgIcon name="question" size={18} style={{ color: 'var(--ia-primary)' }} />
                                                                <span style={{ paddingLeft: '8px' }}>{element.Questions || element.NoOfQues || 0} Questions</span>
                                                            </div>

                                                            <div className='col-6 lg:col-auto flex align-items-center'>
                                                                <SvgIcon name="time" size={18} style={{ color: 'var(--ia-primary)' }} />
                                                                <span style={{ paddingLeft: '8px' }}>{(element.Time || element.Duration || 0) / 60} mins</span>
                                                            </div>

                                                            <div className='col-6 lg:col-auto flex align-items-center'>
                                                                <SvgIcon name="userMaster" size={18} style={{ color: 'var(--ia-primary)' }} />
                                                                <span style={{ paddingLeft: '8px' }}>{element.NoOfStudent !=='0'? (Number(element.NoOfStudent)>1? `${element.NoOfStudent} Attempts`: `${element.NoOfStudent} Attempt`) : 'Not Attempted'} </span>
                                                            </div>
                                                            {element.examYear && (
                                                                <div className='col-6 lg:col-auto flex align-items-center'>
                                                                    <SvgIcon name="date" size={18} style={{ color: 'var(--ia-primary)' }} />
                                                                    <span style={{ paddingLeft: '8px' }}>{element.examYear.split(',').join(', ')}</span>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Card>
                                    )
                                })
                                : list.map((test: any) => {
                                    return (
                                        <Card key={test.Id} className='custome-card ia-testlist mb-5'>
                                            <div className='grid m-0 h-full'>
                                                <div className='col-12 lg:col-3 p-0 tw-relative'>
                                                    <div className="ia-testlist-image">
                                                        <img
                                                            src={test.testSeriesImage || test.Image || "/noimage.png"}
                                                            alt={test.testName || test.Name}
                                                            onError={(e: any) => { e.target.src = "/noimage.png" }}
                                                            className="tw-w-full tw-h-full tw-object-cover"
                                                        />
                                                    </div>
                                                </div>
                                                <div className='col-12 lg:col-9'>
                                                    <div className='ia-testlist-header tw-flex tw-justify-between tw-items-start tw-gap-3 px-2 pt-2'>
                                                        <div className='tw-flex-1'>
                                                            <h2 className='tw-font-bold tw-text-xl lg:tw-text-2xl tw-inline tw-line-clamp-2'>{test.testName || test.Name}</h2>
                                                            <span className='badge-difficulty-level tw-ml-2 tw-inline-flex tw-align-middle'>Level {test.testDifficultyLevel || 1}</span>
                                                        </div>
                                                        <div className='tw-flex-shrink-0'>
                                                            {!isLoggedIn || !isBoardPage ? (
                                                                <button
                                                                    className='ia-btn ia-btn-primary py-2 px-6'
                                                                    onClick={() => checkSubscriptionAndNavigate(`${AppRouteURL.DASHBOARD}${AppRouteURL.MOCKTEST}/${test.testId || test.Id}`)}
                                                                >
                                                                    <span className='tw-text-lg'>Take a Test</span>
                                                                </button>
                                                            ) : isBoardMatched ? (
                                                                <button
                                                                    className='ia-btn ia-btn-primary py-2 px-6'
                                                                    onClick={() => checkSubscriptionAndNavigate(`${AppRouteURL.DASHBOARD}${AppRouteURL.MOCKTEST}/${test.testId || test.Id}`)}
                                                                >
                                                                    <span className='tw-text-lg'>Take a Test</span>
                                                                </button>
                                                            ) : (
                                                                <span className='tw-bg-red-500 tw-text-white tw-px-4 tw-py-2 tw-rounded tw-text-sm tw-font-medium tw-inline-block'>
                                                                    {currentBoardName} is not your target exam
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    <div className='ia-testlist-subheader pb-2'>
                                                        <div className='grid mt-2 px-2 align-items-center'>
                                                            <div className='col-6 lg:col-auto flex align-items-center'>
                                                                <SvgIcon name="question" size={18} style={{ color: 'var(--ia-primary)' }} />
                                                                <span style={{ paddingLeft: '8px' }}>{test.NoOfQues || 0} Questions</span>
                                                            </div>

                                                            <div className='col-6 lg:col-auto flex align-items-center'>
                                                                <SvgIcon name="time" size={18} style={{ color: 'var(--ia-primary)' }} />
                                                                <span style={{ paddingLeft: '8px' }}>{(test.Duration || 0) / 60} mins</span>
                                                            </div>

                                                            <div className='col-6 lg:col-auto flex align-items-center'>
                                                                <SvgIcon name="userMaster" size={18} style={{ color: 'var(--ia-primary)' }} />
                                                                <span style={{ paddingLeft: '8px' }}>{test.NoOfStudent && typeof test.NoOfStudent === 'object' && test.NoOfStudent.data ? test.NoOfStudent.data[0] : (test.NoOfStudent || '0')} Attempts</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Card>
                                    )
                                })
                        ) : (
                            <div className="no-data-section text-center p-5">
                                <div className="no-data-message" style={{ color: '#667085', fontSize: '1.25rem' }}>
                                    No <span style={{ fontWeight: 600, color: '#7f56d9' }}>{topicPriority ? "Recommended Test" : `${heading}`}</span> found!
                                </div>
                            </div>
                        )
                    }
                </div>
                {
                    !topicPriority &&
                    <>
                        {
                            (isTestSeries ? hasMore : (!loadMore && list.length > 10)) && (
                                <div className="lode-more-card">
                                    <button className="ia-btn ia-btn-primary py-2 px-6" onClick={loadMoreClicked} disabled={loading}>
                                        <span className='tw-text-lg'>{loading ? 'Loading...' : 'Load More'}</span>
                                    </button>
                                </div>
                            )
                        }
                    </>
                }

            </section>

            <NoSubscriptionDialog
                {...subscriptionDialogProps}
            />

            <Dialog
                visible={pendingTestDialogProps.visible}
                onHide={pendingTestDialogProps.onHide}
                header="Pending Test"
                style={{ width: '420px' }}
                modal
                draggable={false}
                resizable={false}
                closable={true}
            >
                <div className="tw-text-center tw-py-2">
                    <p className="tw-text-base tw-mb-1">You have a pending test:</p>
                    <p className="tw-font-semibold tw-text-lg tw-mb-4" style={{ color: 'var(--ia-primary)' }}>
                        {pendingTestDialogProps.pendingTest?.TestSeriesName}
                    </p>
                    <p className="tw-text-sm tw-text-gray-500 tw-mb-6">
                        Please complete your pending test before starting a new one. For more details, check your test activity on My Test.
                    </p>
                    <div className="tw-flex tw-justify-center">
                        <button
                            className="ia-btn ia-btn-primary py-2 px-5"
                            onClick={pendingTestDialogProps.onContinue}
                        >
                            Go To My Test
                        </button>
                    </div>
                </div>
            </Dialog>
        </>
    );
};

export default MockTests;